import * as actionTypes from "../actions/actionTypes";

const initialState = {
  error: null,
  loading: false,
};

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_MEETING_SURVEY_START:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.SUBMIT_MEETING_SURVEY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.SUBMIT_MEETING_SURVEY_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

export default surveyReducer;
